import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../contexts/AgendaContext';
// Mui components
import { Typography, Box } from '@mui/material';
// Components
import Consultorio from './Consultorio';

export default function ListadoConsultorios() {
  const theme = useTheme();
  const { prestadorSesion, getPrestadorSesion } = useContext(AgendaContext);

  const [consultoriosPrestador, setConsultoriosPrestador] = useState([])

  useEffect(() => {
    getPrestadorSesion();
  }, []);

  useEffect(() => {
    if (prestadorSesion === null) return;
    setConsultoriosPrestador(prestadorSesion.map(prestador => prestador.consultorios))
  }, [prestadorSesion])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1rem',
        flexDirection: 'column'
      }}>
      <Typography variant="h4">Consultorios</Typography>
      <Box
        sx={{
          border: `2px solid ${theme.palette.backgroundSecondary.main}`,
          borderRadius: '1rem',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <Box
          sx={{
            borderBottom: `2px solid ${theme.palette.backgroundSecondary.main}`,
            display: 'flex',
            padding: '1rem 1.5rem',
            height: '54px'
          }}>
          <Typography sx={{ width: '420px' }} variant="callToAction">
            Dirección
          </Typography>
          <Typography variant="callToAction">Estado</Typography>
        </Box>
        {consultoriosPrestador.length >= 1 &&
          consultoriosPrestador?.map((consultorio, index) => {
            const isLast = index === consultoriosPrestador.length - 1;
            return <Consultorio key={index} consultorio={consultorio[0]} isLast={isLast} />;
          })}
      </Box>
    </Box>
  );
}
